import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { fetchData } from "./Utilities";

const CustomAddCoinModal = ({
  isOpen,
  closeModal,
  onExit,
  onExited,
  userId,
}) => {
  const [userInfo, setUserInfo] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  const saveCoins = async () => {
    if (!coinsNumber) {
      setErrorMessage("لطفا تعداد سکه ها را وارد نمایید.");
      return;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("mob", userInfo?.mob);
    bodyFormData.append("coin", coinsNumber);
    const handleGiftApiResponse = (data) => {
      closeModal();
      SweetAlert({
        title: "",
        text: "تعداد سکه های هدیه  با موفقیت ذخیره شد.",
        type: "success",
      });
    };
    fetchData("giftcoin", bodyFormData, handleGiftApiResponse);
  };

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("uid", userId);
    fetchData("guid", bodyFormData, handleApiResponse);
  }, []);

  const handleApiResponse = (data) => {
    setUserInfo(data?.userinfo);
  };

  const [coinsNumber, setCoinsNumber] = useState(null);
  return (
    <Modal
      show={isOpen}
      onHide={closeModal}
      onExit={onExit}
      onExited={onExited}
      centered
    >
      <Modal.Header>
        <button className="btn-close" onClick={() => closeModal()} />
      </Modal.Header>
      <Modal.Body
        className="justify-content-center mx-4
            "
      >
        <p>
          {" "}
          {userInfo?.name} {userInfo?.family}
        </p>
        <p> {userInfo?.mob}</p>
        <label>تعدد سکه ها:</label>
        <input
          className={`w-100 p-1 form-input `}
          minLength="1"
          maxLength="4"
          type="tel"
          placeholder="تعداد سکه ها را وارد نمایید"
          onChange={(e) => setCoinsNumber(e.target.value)}
          required={true}
        />
      </Modal.Body>
      {errorMessage && (
        <p className="text-danger text-center">{errorMessage}</p>
      )}
      <Modal.Footer className="justify-content-center">
        <Button variant="primary" onClick={() => saveCoins(coinsNumber)}>
          ذخیره
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomAddCoinModal;
